import PropTypes from "prop-types";
import MatchRating from "../data/MatchPrediction.json";
import styles from "./MatchPrediction.module.css";
import classNames from "classnames";
import "moment-timezone";
import { smooth, bgColor, litColor } from "../global/floatColor";

function MatchBox({ league, match_num, language }) {
  const match = MatchRating[league][match_num];
  const Bo = match["Bo"];
  const goal = (Bo + 1) / 2;
  let homePr = smooth(match["winPr"]);
  let awayPr = smooth(1 - match["winPr"]);
  return (
    <div className={styles.MatchBox}>
      <div className={styles.lineup} title={`${match.home} ${match.away}`}>
        <div className={styles.team}>
          <h1>{match.home}</h1>
        </div>
        <div className={styles.vs}>
          <h3 style={{ marginBottom: "5px" }}>vs</h3>
        </div>
        <div className={styles.team}>
          <h1>{match.away}</h1>
        </div>
      </div>
      <table className={styles.table}>
        <tbody>
          <tr>
            <td colSpan={goal}>{language === "en" ? "Win" : "승리"}</td>
            <td colSpan={goal} className={styles.block_left}>
              {language === "en" ? "Win" : "승리"}
            </td>
          </tr>
          <tr>
            <td
              colSpan={goal}
              style={{ background: bgColor(homePr), color: litColor(homePr) }}
              className={styles.block_bottom}
            >
              {homePr}%
            </td>
            <td
              colSpan={goal}
              style={{ background: bgColor(awayPr), color: litColor(awayPr) }}
              className={classNames([styles.block_left, styles.block_bottom])}
            >
              {awayPr}%
            </td>
          </tr>
          <tr>
            {match["prediction"].map((pr, idx) => {
              if (idx < goal)
                return (
                  <td
                    key={`win_${idx}`}
                    className={idx === 0 ? null : styles.block_left}
                  >
                    {goal}:{idx} {language === "en" ? "Win" : "승리"}
                  </td>
                );
              if (idx === goal) return null;
              return (
                <td key={`win_${idx}`} className={styles.block_left}>
                  {Bo + 1 - idx}:{goal} {language === "en" ? "Win" : "승리"}
                </td>
              );
            })}
          </tr>
          <tr>
            {match["prediction"].map((_pr, idx) => {
              let pr = smooth(_pr);
              if (idx < goal)
                return (
                  <td
                    key={`winPr_${idx}`}
                    style={{ background: bgColor(pr), color: litColor(pr) }}
                    className={classNames([
                      idx === 0 ? null : styles.block_left,
                      styles.block_bottom,
                    ])}
                  >
                    {pr}%
                  </td>
                );
              if (idx === goal) return null;
              return (
                <td
                  key={`winPr_${idx}`}
                  style={{ background: bgColor(pr), color: litColor(pr) }}
                  className={classNames([
                    styles.block_left,
                    styles.block_bottom,
                  ])}
                >
                  {pr}%
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
}

MatchBox.propTypes = {
  league: PropTypes.string.isRequired,
  match_num: PropTypes.number.isRequired,
  language: PropTypes.string.isRequired,
};

export default MatchBox;
